import FileLoader from './fileLoader';

let _uidCounter = 0;

function generateUID() {
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 1e9);
  return `2.25.${timestamp}.${random}.${++_uidCounter}`;
}

const PDFFileLoader = new (class extends FileLoader {
  fileType = 'application/pdf';

  loadFile(file, imageId) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(reader.error);
      reader.readAsArrayBuffer(file);
    });
  }

  getDataset(arrayBuffer, imageId) {
    const dataset = {
      SOPClassUID: '1.2.840.10008.5.1.4.1.1.104.1',
      Modality: 'DOC',
      SeriesDescription: imageId || 'PDF Document',
      StudyInstanceUID: generateUID(),
      SeriesInstanceUID: generateUID(),
      SOPInstanceUID: generateUID(),
      EncapsulatedDocument: [arrayBuffer],
      MIMETypeOfEncapsulatedDocument: 'application/pdf',
      url: imageId,
    };
    return dataset;
  }
})();

export default PDFFileLoader;
